// Author NYA
// Date 2021-03-08 14:06:34

class SithMesPrdShiftHandover {
constructor({
        id = null,
        prdPpOperationId = '',
        actualMstLocationId = '',
        actualMstLocationName = '',
        mstShiftTeamFromId = '',
        mstShiftTeamFromName = '',
        beginDatetime = '',
        endDatetime = '',
        shiftContent = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdPpOperationId = prdPpOperationId;
    this.actualMstLocationId = actualMstLocationId;
    this.actualMstLocationName = actualMstLocationName;
    this.mstShiftTeamFromId = mstShiftTeamFromId;
    this.mstShiftTeamFromName = mstShiftTeamFromName;
    this.beginDatetime = beginDatetime;
    this.endDatetime = endDatetime;
    this.shiftContent = shiftContent;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdShiftHandover();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationName',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.prdPpOperationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualMstLocationName',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.actualMstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftTeamFromName',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.mstShiftTeamFromName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'beginDatetime',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.beginDatetime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftContent',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.shiftContent',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByUserName',
        label: 'label.sith.prd.sithMesPrdShiftHandover.grid.createdByUserName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
    ])}

const filter = {
    projectCodeFilter : "",
    orderCodeFilter : "",
    prdPpOperationIdFilter : "",
    prdPpOperationNameFilter : "",
    actualMstLocationIdFilter : "",
    actualMstLocationNameFilter : "",
    mstShiftTeamFromIdFilter : "",
    mstShiftTeamFromNameFilter : "",
    beginDatetimeRteFilter : "",
    beginDatetimeLteFilter : "",
    endDatetimeRteFilter : "",
    endDatetimeLteFilter : "",
    shiftContentFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNodeCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdShiftHandover.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdShiftHandover.filter.orderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prdPpOperationNameFilter',
        label: 'label.sith.prd.sithMesPrdShiftHandover.filter.prdPpOperationName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'actualMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdShiftHandover.filter.actualMstLocationName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'beginDatetimeRteFilter',
        label: 'label.sith.prd.sithMesPrdShiftHandover.filter.beginDatetimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'beginDatetimeLteFilter',
        label: 'label.sith.prd.sithMesPrdShiftHandover.filter.beginDatetimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'prdPpOperationId',
        label: 'label.sith.prd.sithMesPrdShiftHandover.entity.prdPpOperationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'actualMstLocationName',
        label: 'label.sith.prd.sithMesPrdShiftHandover.entity.actualMstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"actualMstLocationId":"id"}'
                }
        },
        {
        key: 'mstShiftTeamFromName',
        label: 'label.sith.prd.sithMesPrdShiftHandover.entity.mstShiftTeamFromName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstShiftTeam'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstShiftTeamFromId":"id"}'
                }
        },
        {
        key: 'beginDatetime',
        label: 'label.sith.prd.sithMesPrdShiftHandover.entity.beginDatetime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endDatetime',
        label: 'label.sith.prd.sithMesPrdShiftHandover.entity.endDatetime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'shiftContent',
        label: 'label.sith.prd.sithMesPrdShiftHandover.entity.shiftContent',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdShiftHandover.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdShiftHandover, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
